import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { Box, Rating, Typography } from "@mui/material";
import TenantAvatar from "../../components/mssp/TenantAvatar";
import { getPrettyDate } from "../../utils/timestamp";
import RecentlyFoundLabel, {
  isRecentlyFound,
} from "../posture/controls/components/RecentlyFoundLabel";
import FilterChip from "../posture/scenarios/components/Header/FilterChip";
import EditOrDeleteTenantButton from "./EditOrDeleteTenantButton";
import PinIcon from "./PinIcon";

export const getTenantsManagementColumns = (
  colors,
  msspId,
  handlePinClick,
  handleLabelDelete,
  showLocalTime
) => [
  {
    field: "is_main_tenant",
    headerName: "",
    flex: 0,
    width: 0,
    minWidth: 0,
    sortable: true,
    // Hide this column as it's only used for sorting
    hide: true,
    disableColumnMenu: true,
    disableExport: true,
    renderHeader: () => null,
    renderCell: () => null,
  },
  {
    field: "is_pinned",
    headerName: "",
    flex: 0.1,
    disableExport: true,
    renderCell: (params) => {
      return (
        <PinIcon
          isPinned={params.value}
          onClick={(e) =>
            handlePinClick(params.row.customer_id, params.value, e)
          }
        />
      );
    },
  },
  {
    field: "company_name",
    headerName: "Tenant",
    flex: 1,
    minWidth: 200,
    renderCell: (params) => {
      return (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={"10px"}>
          <TenantAvatar tenant={params.row} size={20} />
          <Typography variant="caption">{params.value}</Typography>
          {isRecentlyFound(params.row?.creation_date) && (
            <RecentlyFoundLabel
              foundTimestamp={params.row?.creation_date || ""}
            />
          )}
        </Box>
      );
    },
  },
  {
    field: "importance",
    headerName: "Importance",
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => {
      return (
        <Rating
          name="importance"
          value={params.value}
          readOnly
          icon={
            <StarRoundedIcon
              fontSize="inherit"
              style={{ color: colors.rating_checked_enabled }}
            />
          }
          emptyIcon={
            <StarRoundedIcon
              fontSize="inherit"
              style={{ color: colors.rating_unchecked_enabled }}
            />
          }
        />
      );
    },
  },
  {
    field: "labels",
    headerName: "Labels",
    sortable: false,
    flex: 1,
    minWidth: 150,
    // Format the labels to be a comma-separated list in exported CSV
    valueFormatter: (params) => {
      return params.value && params.value.length > 0
        ? params.value.join(", ")
        : "";
    },
    renderCell: (params) => {
      return (
        <Box display="flex" gap={1} flexWrap="wrap">
          {params.value?.map((label, index) => (
            <FilterChip
              key={index}
              label={label}
              handleDelete={() =>
                handleLabelDelete(params.row.id, params.value, label)
              }
              handleOnCLick={() => {}}
              clickable={false}
            />
          ))}
        </Box>
      );
    },
  },
  {
    field: "creation_date",
    headerName: "Created On",
    flex: 0.5,
    minWidth: 120,
    valueFormatter: (params) =>
      getPrettyDate(params.value, showLocalTime) || null,
    renderCell: (params) => (
      <Typography variant="caption" color={colors.text_primary}>
        {params.value ? getPrettyDate(params.value, showLocalTime) : "-"}
      </Typography>
    ),
  },
  {
    field: "actions",
    headerName: "",
    align: "right",
    disableExport: true,
    sortable: false,
    flex: 0.01,
    renderCell: (params) => {
      return (
        <Box sx={{ marginRight: "16px" }}>
          <EditOrDeleteTenantButton
            msspId={msspId}
            tenant={params.row}
            disabledDelete={params.row.customer_id === msspId}
          />
        </Box>
      );
    },
  },
];
